import React from "react";

const healthTips = [
  {
    id: 1,
    text: "Choose a healthy diet, eat a variety of foods rich in potassium, fiber, protein, lower in salt (sodium) and saturated fat",
  },
  { id: 2, text: "Keep yourself at a healthy weight" },
  {
    id: 3,
    text: "Be physically active for about 30 minutes a day, 5 days a week",
  },
  { id: 4, text: "Do not smoke" },
  { id: 5, text: "Quit alcohol consumption" },
  { id: 6, text: "Get enough sleep" },
  { id: 7, text: "Stay hydrated" },
];

const HypertensionFacts = () => {
  return (
    <>
   
   <section className="overflow-hidden  mx-auto xl:p-10 xl:mr-32 xl:ml-44 lg:mt-16 p-6">
      <div
        className="flex items-center gap-10"
        data-aos="fade-left"
        data-aos-easing="linear"
        data-aos-duration="1000"
        crossOrigin="anonymous"
      >

      <svg
          width="40"
          height="60"
          viewBox="0 0 53 63"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M44.7968 29.9533C43.0298 38.3342 35.51 44.6309 26.5 44.6309C17.49 44.6309 9.97023 38.3342 8.20315 29.9533H17.0623C17.4813 31.716 18.3929 33.2901 19.6449 34.5268C21.3983 36.2599 23.8226 37.3328 26.5012 37.3328C28.9567 37.3328 31.2101 36.4151 32.9298 34.9037C33.077 34.788 33.2192 34.6623 33.3563 34.5268C34.6084 33.2901 35.52 31.716 35.939 29.9533H44.7968ZM8.98506 55.6391H23.2913V52.1507C17.2568 51.4314 11.8458 48.7092 7.76294 44.6752C2.96551 39.9379 0 33.3936 0 26.1657C0 18.939 2.96551 12.396 7.76294 7.65863C9.41155 6.03026 11.2634 4.54846 13.2912 3.35982C21.0092 -1.1644 32.3138 -1.12499 39.9732 3.51133C41.8987 4.67656 43.662 6.10047 45.2383 7.65863C50.0345 12.396 53 18.939 53 26.1669C53 33.3936 50.0345 39.9379 45.2383 44.6752C41.1542 48.7092 35.7432 51.4314 29.7074 52.1507V55.6391H44.0137C46.4854 55.6391 48.5056 57.6431 48.5056 60.0758V63H4.49315V60.0758C4.49315 57.6345 6.51464 55.6391 8.98506 55.6391ZM26.5 3.97816C38.9095 3.97816 48.9683 13.9135 48.9683 26.1706C48.9683 38.4266 38.9095 48.3631 26.5 48.3631C14.0905 48.3631 4.03174 38.4266 4.03174 26.1706C4.03174 13.9135 14.0905 3.97816 26.5 3.97816ZM15.8015 10.9807C15.4324 10.35 15.6493 9.54321 16.2866 9.17738C16.9251 8.81279 17.7419 9.02834 18.111 9.65777L19.7808 12.513C20.15 13.1424 19.933 13.9504 19.2945 14.315C18.6572 14.6796 17.8392 14.4653 17.47 13.8359L15.8015 10.9807ZM9.5824 18.4032C8.94515 18.0423 8.72442 17.2367 9.09106 16.6061C9.45645 15.9767 10.272 15.7599 10.9093 16.1208L13.8 17.7689C14.4372 18.1298 14.6579 18.9353 14.2913 19.566C13.9259 20.1954 13.1103 20.4122 12.4731 20.0513L9.5824 18.4032ZM42.0907 15.3768C42.728 15.0159 43.5436 15.2327 43.9089 15.8621C44.2756 16.4928 44.0548 17.2983 43.4176 17.6592L40.5269 19.3073C39.8897 19.6682 39.0741 19.4514 38.7087 18.822C38.3421 18.1913 38.5628 17.3858 39.2 17.0249L42.0907 15.3768ZM34.5697 9.23405C34.9351 8.60462 35.7507 8.38783 36.3879 8.74873C37.0264 9.10964 37.2459 9.9152 36.8805 10.5459L35.212 13.3998C34.8453 14.0293 34.031 14.2473 33.3925 13.8851C32.7552 13.5242 32.5358 12.7187 32.9011 12.0892L34.5697 9.23405ZM24.9449 7.62045C24.9449 6.89125 25.5435 6.29878 26.2818 6.29878C27.0213 6.29878 27.6199 6.89125 27.6199 7.62045V10.9178C27.6199 11.647 27.0213 12.2395 26.2818 12.2395C25.5435 12.2395 24.9449 11.647 24.9449 10.9178V7.62045ZM28.63 23.8451C30.0367 24.594 30.9944 26.0647 30.9944 27.7559C30.9944 30.2071 28.9829 32.1939 26.5012 32.1939C24.0196 32.1939 22.0068 30.2071 22.0068 27.7559C22.0068 26.0647 22.9646 24.594 24.3738 23.8451V16.8771L26.5012 14.7757L28.63 16.8771V23.8451Z"
            fill="#2D95A5"
          />
        </svg>

        <h1 className="text-textColor text-2xl lg:text-4xl font-inter font-semibold  ">
          Hypertension
        </h1>

       
      </div>

      {/* Hypertension Description */}
      <div
        className="mt-6 mb-8"
        data-aos="fade-up"
        data-aos-easing="linear"
        data-aos-duration="1000"
        crossOrigin="anonymous"
      >
        <p className="text-textColor/80 text-sm md:text-base lg:text-lg font-inter font-normal text-justify leading-relaxed max-w-4xl">
          Hypertension, also known as high blood pressure, is a condition where the force of blood pushing against the artery walls is consistently too high. This can lead to serious health problems if left untreated, such as heart disease, stroke, and kidney failure.
        </p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 lg:gap-10 lg:mt-10">
        <div
          className="col-span-1 mt-5"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="1000"
          crossOrigin="anonymous"
        >
          <h3 className="text-textColor text-xl lg:text-2xl font-inter font-semibold ">
            Lifestyle changes to lower blood pressure
          </h3>
          <p className="text-textColor/75 mt-3 mb-2 text-md text-justify font-inter font-normal ">
            You can maintain your blood pressure in a healthy state by living a
            healthy lifestyle
          </p>

          <div className="space-y-5 mt-4">
            {healthTips.map((item, index) => (
              <div key={index} className="flex items-center gap-5">
                <div>
                  <svg
                    width="41"
                    height="40"
                    viewBox="0 0 41 40"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clipPath="url(#clip0_40_3572)">
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M20.4996 0.00332381C21.5907 -0.0426306 22.4515 0.331569 23.319 0.873174C24.4201 1.55921 25.6613 2.91814 27.1928 3.77815C29.3449 4.98937 33.3355 3.3186 35.3775 6.30564C36.5686 8.04534 36.6254 9.41084 36.7121 10.7599C36.8089 12.2141 37.0658 13.5533 38.5806 15.5228C41.0864 18.7823 41.6069 20.952 40.3156 23.2136C39.4348 24.7563 37.583 25.613 37.1525 26.5879C36.2417 28.6657 37.2493 30.2315 36.0014 32.6539C35.1339 34.3345 33.7959 35.4407 32.0142 36.0053C30.5127 36.4812 29.0013 35.7919 27.8001 36.2909C25.6847 37.164 24.1265 39.1958 22.4415 39.7112C21.7909 39.9081 21.1436 40.0066 20.4996 40.0033C19.8523 40.0066 19.205 39.9114 18.5577 39.7112C16.8761 39.1958 15.3146 37.1673 13.1992 36.2909C11.9947 35.7919 10.4865 36.4812 8.98507 36.0053C7.20333 35.4407 5.86536 34.3345 4.99784 32.6539C3.74662 30.2315 4.75761 28.6657 3.84338 26.5879C3.41296 25.613 1.56116 24.7563 0.680298 23.2136C-0.610962 20.952 -0.0871179 18.7823 2.41532 15.5228C3.93013 13.5533 4.18705 12.2141 4.28381 10.7599C4.3739 9.41084 4.42729 8.04534 5.61845 6.30564C7.66044 3.3186 11.651 4.98937 13.8031 3.77815C15.3346 2.91814 16.5725 1.55921 17.6769 0.873174C18.5477 0.331569 19.4086 -0.0426306 20.4996 0.00332381ZM16.9595 17.6925L19.5821 20.1478L24.0965 15.6344C24.5436 15.188 24.8239 14.8302 25.3744 15.3882L27.1628 17.1903C27.75 17.7614 27.72 18.0962 27.1661 18.628L20.6031 24.9664C19.4353 26.0923 19.6388 26.1612 18.4543 25.0058L13.9499 20.5974C13.703 20.3349 13.7297 20.069 14 19.8064L16.0753 17.6892C16.3856 17.3675 16.6359 17.3872 16.9595 17.6925ZM20.4396 9.04977C26.7624 9.04977 31.8841 14.0916 31.8841 20.3086C31.8841 26.5288 26.7591 31.5674 20.4396 31.5674C14.1167 31.5674 8.99508 26.5256 8.99508 20.3086C8.99508 14.0883 14.1201 9.04977 20.4396 9.04977Z"
                        fill="#2D95A5"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_40_3572">
                        <rect width="41" height="40" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </div>

                <p
                  className="text-textColor text-base font-inter text-
                 font-semibold text-justify lg:text-start"
                >
                  {item.text}
                </p>
              </div>
            ))}
          </div>
        </div>

        <div
          className="col-span-1"
          data-aos="fade-left"
          data-aos-easing="linear"
          data-aos-duration="1000"
          crossOrigin="anonymous"
        >
          <img src="/assets/New-Hero/know.png" alt="hypertension" />
        </div>
      </div>
    </section>
  
    </>
    
  );
};

export default HypertensionFacts;


